import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from 'containers/Full'

// Views - Auth
import Apps from 'views/apps/Apps'
import App from 'views/apps/App'
import Devices from 'views/devices/Devices'
import Device from 'views/devices/Device'
import CurlPurchases from 'views/curl/CurlPurchases'
import CurlCatalog from 'views/curl/CurlCatalog'

// Views - Files
import Files from 'views/files/Files'
import File from 'views/files/File'

// Views - Store
import Products from 'views/products/Products'
import Product from 'views/products/Product'

// Views - Store Assets
import Promotions from 'views/promotions/Promotions'
import Promotion from 'views/promotions/Promotion'
import Previews from 'views/previews/Previews'
import Preview from 'views/previews/Preview'

// Views - Offers
import Offers from 'views/offers/Offers'
import Offer from 'views/offers/Offer'

// Views - Catelogs
import Catalogs from 'views/catalogs/Catalogs'
import Catalog from 'views/catalogs/Catalog'
import CatalogDevops from 'views/catalogs/CatalogDevops'

// Views - Pages
import Login from 'views/pages/Login'

// Views - Admin
import ActivityLogs from 'views/admin/ActivityLogs'

// Services
import authentication from 'services/authentication'

Vue.use(Router)

const router = new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/apps',
      name: 'Home',
      component: Full,
      meta: {requiresAuth: true},
      children: [
        {
          path: 'apps',
          meta: {
            label: 'Apps'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Apps',
              meta: {
                label: 'List'
              },
              component: Apps
            },
            {
              path: ':id',
              name: 'App',
              meta: {
                label: 'Show'
              },
              component: App
            }
          ]
        },
        {
          path: 'promotions',
          meta: {
            label: 'Promotions'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Promotions',
              meta: {
                label: 'List'
              },
              component: Promotions
            },
            {
              path: ':id',
              name: 'Promotion',
              meta: {
                label: 'Show'
              },
              component: Promotion
            }
          ]
        },
        {
          path: 'previews',
          meta: {
            label: 'Previews'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Previews',
              meta: {
                label: 'List'
              },
              component: Previews
            },
            {
              path: ':id',
              name: 'Preview',
              meta: {
                label: 'Show'
              },
              component: Preview
            }
          ]
        },
        {
          path: 'offers',
          meta: {
            label: 'Offers'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Offers',
              meta: {
                label: 'List'
              },
              component: Offers
            },
            {
              path: ':id',
              name: 'Offer',
              meta: {
                label: 'Show'
              },
              component: Offer
            }
          ]
        },
        {
          path: 'catalogs',
          meta: {
            label: 'Catalogs'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Catalogs',
              meta: {
                label: 'List'
              },
              component: Catalogs
            },
            {
              path: ':id',
              name: 'Catalog',
              meta: {
                label: 'Show'
              },
              component: Catalog
            },
            {
              path: ':id/devops',
              name: 'CatalogDevops',
              meta: {
                label: 'Show'
              },
              component: CatalogDevops
            }
          ]
        },
        {
          path: 'products',
          meta: {
            label: 'Products'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Products',
              meta: {
                label: 'List'
              },
              component: Products
            },
            {
              path: ':id',
              name: 'Product',
              meta: {
                label: 'Show'
              },
              component: Product
            }
          ]
        },
        {
          path: 'files',
          meta: {
            label: 'Files'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Files',
              meta: {
                label: 'List'
              },
              component: Files
            },
            {
              path: ':id',
              name: 'File',
              meta: {
                label: 'Show'
              },
              component: File
            }
          ]
        },
        {
          path: 'devices',
          meta: {
            label: 'Devices'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'Devices',
              meta: {
                label: 'List'
              },
              component: Devices
            },
            {
              path: ':id',
              name: 'Device',
              meta: {
                label: 'Show'
              },
              component: Device
            }
          ]
        },
        {
          path: 'curl',
          meta: {
            label: 'CURL',
            disabled: true
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'purchases',
              name: 'CurlPurchases',
              meta: {
                label: 'Purchases'
              },
              component: CurlPurchases
            },
            {
              path: 'catalog',
              name: 'CurlCatalog',
              meta: {
                label: 'Catalog'
              },
              component: CurlCatalog
            }
          ]
        },
        {
          path: 'admin',
          redirect: '/admin/activity_logs',
          meta: {
            label: 'Admin'
          },
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'activity_logs',
              name: 'ActivityLogs',
              meta: {
                label: 'Activity Logs'
              },
              component: ActivityLogs
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/login',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!authentication.loggedIn()) {
      next({
        path: '/pages/login'
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js